import React from 'react';

import DangerZoneCard from './subcomponents/dangerZoneCard';
import UserFormCard from './subcomponents/userFormCard';
import ResetPasswordCard from './subcomponents/resetPasswordCard';

const AccountSettings = () => (
  <>
    <UserFormCard />
    <ResetPasswordCard />
    <DangerZoneCard />
  </>
);

export default AccountSettings;
